import type { MutationHookOptions } from '@apollo/client'
import { MyTrainingRequestsDatatableDocument } from 'generated/resources/datatable.graphql'
import {
  CreateTrainingRequestDocument,
  CreateTrainingRequestMutation,
  CreateTrainingRequestMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  CreateTrainingRequestMutation,
  CreateTrainingRequestMutationVariables
>

export const useCreateTrainingRequest = (options?: Options) => {
  const [createTrainingRequest, { loading }] = useMutation(CreateTrainingRequestDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.createTrainingsTrainingRequest,
  })

  return {
    loading,
    create(variables: CreateTrainingRequestMutationVariables) {
      return createTrainingRequest({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [MyTrainingRequestsDatatableDocument],
      })
    },
  }
}
